// This is no longer really a target, but more of an ultimate
// emissive boost strength - kind of trial and error against
// the post process bloom threshold
const float bloomTarget = 1.0;

// Grab a reference to the existing emissive radiance
// which includes the emissive map, color, and intensity
vec3 emissive = totalEmissiveRadiance.rgb;

// Grab the most emissive channel to determine presence of emissive color
float presence = max(emissive.r, max(emissive.g, emissive.b));

// Perceptual brightness (hue-biased): controls how strong it should be
// These values come from the Rec.709 luma coefficients, which represent
// the perceived brightness of each channel (red looking darker than blue, etc.)
float emissiveLuma = dot(emissive, vec3(0.2126, 0.7152, 0.0722));

// Lower picks up darker colors (tested with DMG Skylla)
float onStart = 0.02;
// How quickly it ramps to "on" (tested with Themberchaud onComplete)
float onFull  = 0.42;
// Gate based on presence so we pick up most all emissive colors
// We end up with a 0.0 to 1.0 mask for how much to apply bloom boost
float mask = smoothstep(onStart, onFull, presence);

if (mask > 0.0) {
    // high end boost based on our target and emissive luma of at least 1.0 so we don't
    // unintentionally reduce any emissive colors
    float sNorm = clamp(bloomTarget / max(emissiveLuma, 1e-4), 1.0, 64.0);

    // low end boost to help mid values, also driven by presence mask
    // adjust multiplier to increase low end boost
    float softMultiplier = 4.0;
    float sSoft = 1.0 + softMultiplier * mask;

    // Blend between soft and normal based on mask
    float blended = mix(sSoft, sNorm, mask);

    // Final blend between 1.0 and our blended luma-based boost based on mask
    // The final emissive radiance may not reach the post processing
    // bloom threshold, but this will still boost emissive colors
    // notably on Concord and Cauldron dice sets
    totalEmissiveRadiance *= mix(1.0, blended, mask);
}
